<template>
  <div class="ai-message-container" :class="{ 'system-message': isSystem }">
    <div class="ai-avatar">
      <span>AI</span>
    </div>
    <div class="ai-message-content">
      <div
        class="message-text"
        :class="{ 'error-message': isError, 'system-message-text': isSystem }"
        v-html="formattedContent"
      ></div>
      <div class="message-actions" v-if="!isError && !isSystem">
        <button class="action-button copy-button" @click="copyMessage" title="复制内容">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M8 5H6C4.89543 5 4 5.89543 4 7V19C4 20.1046 4.89543 21 6 21H16C17.1046 21 18 20.1046 18 19V17M8 5C8 6.10457 8.89543 7 10 7H12C13.1046 7 14 6.10457 14 5M8 5C8 3.89543 8.89543 3 10 3H12C13.1046 3 14 3.89543 14 5M14 5H16C17.1046 5 18 5.89543 18 7V10M20 14H10M10 14L13 11M10 14L13 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="action-button thumb-up" @click="rateMessage(true)" :class="{ active: rated === 'up' }" title="有帮助">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1939 20.9197 20.4658 19.4562L21.5723 12.4562C21.9082 10.6389 20.5122 9 18.5328 9H14C13.4477 9 13 8.55228 13 8V4.46584C13 3.10399 11.896 2 10.5342 2C10.2093 2 9.91358 2.1913 9.78778 2.48812L6.29289 10.2929C6.10536 10.6834 5.70711 11 5.29289 11H4C2.89543 11 2 11.8954 2 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="action-button thumb-down" @click="rateMessage(false)" :class="{ active: rated === 'down' }" title="没帮助">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M17 2V13M22 11V4C22 2.89543 21.1046 2 20 2H6.57381C5.09296 2 3.80606 3.08027 3.53415 4.54379L2.42775 11.5438C2.09178 13.3611 3.48773 15 5.46741 15H10C10.5523 15 11 15.4477 11 16V19.5342C11 20.896 12.104 22 13.4658 22C13.7907 22 14.0864 21.8087 14.2122 21.5119L17.7071 13.7071C17.8946 13.3166 18.2929 13 18.7071 13H20C21.1046 13 22 12.1046 22 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { formatMarkdown } from '../utils/formatter'

export default {
  props: {
    content: {
      type: String,
      required: true
    },
    isError: {
      type: Boolean,
      default: false
    },
    isSystem: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rated: null
    }
  },
  computed: {
    formattedContent() {
      if (this.isError) {
        return this.content
      }
      return formatMarkdown(this.content)
    }
  },
  methods: {
    copyMessage() {
      navigator.clipboard.writeText(this.content).then(() => {
        // 成功复制
        console.log('内容已复制到剪贴板')
      }).catch(err => {
        console.error('复制失败:', err)
      })
    },
    rateMessage(isLike) {
      this.rated = isLike ? 'up' : 'down'
      // 可以在这里添加评分发送到后端的逻辑
    },
    addCopyButtonToCodeBlock(codeBlock) {
      // 检查是否已经有复制按钮
      if (codeBlock.querySelector('.code-copy-button')) return

      const copyButton = document.createElement('button')
      copyButton.className = 'code-copy-button'
      copyButton.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="currentColor"/></svg>'
      copyButton.title = '复制代码'

      copyButton.addEventListener('click', () => {
        const code = codeBlock.querySelector('code').innerText
        navigator.clipboard.writeText(code).then(() => {
          copyButton.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/></svg>'
          copyButton.classList.add('copied')

          setTimeout(() => {
            copyButton.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="currentColor"/></svg>'
            copyButton.classList.remove('copied')
          }, 2000)
        })
      })

      codeBlock.appendChild(copyButton)
    },
    updateCodeBlocks() {
      this.$nextTick(() => {
        const codeBlocks = document.querySelectorAll('pre.code-block')
        codeBlocks.forEach(this.addCopyButtonToCodeBlock)
      })
    }
  },
  mounted() {
    this.updateCodeBlocks()
  },
  updated() {
    this.updateCodeBlocks()
  }
}
</script>

<style scoped>
.ai-message-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 4px;
  padding: 4px 0;
}

.ai-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: white;
  margin-right: 12px;
  flex-shrink: 0;
}

.system-message .ai-avatar {
  background-color: #6b7280;
}

.ai-message-content {
  max-width: 80%;
  display: flex;
  flex-direction: column;
}

.message-text {
  padding: 10px 14px;
  background-color: white;
  color: #1f2937;
  border-radius: 12px;
  border-top-left-radius: 2px;
  font-size: 15px;
  line-height: 1.6;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  word-break: break-word;
  animation: fadeIn 0.3s ease;
}

.error-message {
  background-color: #fee2e2;
  color: #b91c1c;
}

.system-message-text {
  background-color: #f3f4f6;
  color: #4b5563;
  font-style: italic;
}

.message-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
  opacity: 0;
  transition: opacity 0.2s;
}

.ai-message-container:hover .message-actions {
  opacity: 1;
}

.action-button {
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  margin-left: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-button:hover {
  color: #4b5563;
  background-color: #f3f4f6;
}

.action-button.active {
  color: #3b82f6;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<style>
pre.code-block {
  position: relative;
  background-color: #f8fafc;
  border-radius: 8px;
  margin: 16px 0;
  padding: 16px;
  overflow: auto;
}

.code-block code {
  font-family: "SFMono-Regular", Menlo, Consolas, "PT Mono", "Liberation Mono", Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  color: #334155;
}

.code-copy-button {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}

pre.code-block:hover .code-copy-button {
  opacity: 1;
}

.code-copy-button:hover {
  background: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.code-copy-button.copied {
  background: #dcfce7;
  color: #16a34a;
  border-color: #bbf7d0;
}

/* 语法高亮 */
.hljs-keyword {
  color: #8b5cf6;
}

.hljs-string {
  color: #10b981;
}

.hljs-number {
  color: #f59e0b;
}

.hljs-comment {
  color: #6b7280;
  font-style: italic;
}

.hljs-function {
  color: #3b82f6;
}

.hljs-title {
  color: #0ea5e9;
}
</style>
